export const MODERNIZE_CONFLUENCE_IPM_MODAL_ONBOARDING_STATE_KEYS: Record<
	string,
	`modernize-confluence-ipm-modal:${string}`
> = {
	hasDismissedModernizeConfluenceIpmModal:
		'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
} as const;
